"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const NumberFormatter_1 = __importDefault(require("@react/web/Common/NumberFormatter/NumberFormatter"));
const AllPricesView = (price) => react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("div", { className: "price-offer-price withoutVat" },
        react_1.default.createElement("div", { className: "price" },
            react_1.default.createElement("span", { className: "withoutVatPrice" }, NumberFormatter_1.default.formatPrice(price.withoutVat)),
            react_1.default.createElement("span", { className: "vat-info" }, "\u00A0bez DPH")),
        react_1.default.createElement("div", { className: "price" },
            react_1.default.createElement("span", { className: "withVatPrice" }, NumberFormatter_1.default.formatPrice(price.withVat)),
            react_1.default.createElement("span", { className: "vat-info" }, "\u00A0s DPH"))),
    react_1.default.createElement("div", { className: "price-offer-price withVat" },
        react_1.default.createElement("div", { className: "price" },
            react_1.default.createElement("span", { className: "withVatPrice" }, NumberFormatter_1.default.formatPrice(price.withVat)),
            react_1.default.createElement("span", { className: "vat-info" }, "\u00A0s DPH")),
        react_1.default.createElement("div", { className: "price" },
            react_1.default.createElement("span", { className: "withoutVatPrice" }, NumberFormatter_1.default.formatPrice(price.withoutVat)),
            react_1.default.createElement("span", { className: "vat-info" }, "\u00A0bez DPH"))));
exports.default = AllPricesView;
